import React from "react";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import MyVerticallyCenteredModal from "./modal";

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
`;
const inline = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
  .d-inline{
    display: inline-block;
   }
`;
const tradesection = () => {
    const [modalShow, setModalShow] = React.useState(false);
  return (
    <div className="row">
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <div className="col-lg-5 third-right-section">
        <img
        className="third-section-image"
          src="https://res.cloudinary.com/drr1rnoxf/image/upload/v1687439689/Frame_y6gtvr.svg"
          alt="..."
        />
      </div>
      <div className="col-lg-7">
        <div className="row">
          <div className="col-lg-6 col-md-6 mb-3">
            <div className="section-card f-boxed style-3">
              <div className="text">
                <Reveal
                  className="onStep"
                  keyframes={fadeInUp}
                  delay={100}
                  duration={600}
                  triggerOnce
                >
                  <h4 className="">Generate a fixed income</h4>
                </Reveal>
                <Reveal
                  className="onStep"
                  keyframes={fadeInUp}
                  delay={200}
                  duration={600}
                  triggerOnce
                ></Reveal>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 mb-3">
            <div className="section-card f-boxed style-3">
              <div className="text">
                <Reveal
                  className="onStep"
                  keyframes={fadeInUp}
                  delay={100}
                  duration={600}
                  triggerOnce
                >
                  <h4 className="">
                    Earn exposure to large <br /> ecosystems
                  </h4>
                </Reveal>
                <Reveal
                  className="onStep"
                  keyframes={fadeInUp}
                  delay={200}
                  duration={600}
                  triggerOnce
                ></Reveal>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 mb-3">
            <div className="section-card f-boxed style-3">
              <div className="text">
                <Reveal
                  className="onStep"
                  keyframes={fadeInUp}
                  delay={100}
                  duration={600}
                  triggerOnce
                >
                  <h4 className="">
                    Benefit from liquidity in <br />
                    secondary markets
                  </h4>
                </Reveal>
                <Reveal
                  className="onStep"
                  keyframes={fadeInUp}
                  delay={200}
                  duration={600}
                  triggerOnce
                ></Reveal>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 mb-3">
            <div className="section-card f-boxed style-3">
              <div className="text">
                <Reveal
                  className="onStep"
                  keyframes={fadeInUp}
                  delay={100}
                  duration={600}
                  triggerOnce
                >
                  <h4 className="">Diversify your portfolio risk</h4>
                </Reveal>
                <Reveal
                  className="onStep"
                  keyframes={fadeInUp}
                  delay={200}
                  duration={600}
                  triggerOnce
                ></Reveal>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-6 mb-3 d-flex justify-content-center">
            <Reveal
              className="onStep d-inline"
              keyframes={inline}
              delay={800}
              duration={900}
              triggerOnce
            >
              <span
                  onClick={() =>window.open(
                    "https://app.raiserdapp.com/",
                    "_blank"
                  )}
                className="btn-main inline lead"
              >
                Browse New Issuances
              </span>
              <div className="mb-sm-30"></div>
            </Reveal>
          </div>

          <div className="col-lg-6 col-md-6 mb-3 d-flex justify-content-center">
            <Reveal
              className="onStep d-inline"
              keyframes={inline}
              delay={800}
              duration={900}
              triggerOnce
            >
              <span
                  onClick={() =>window.open(
                    "https://app.raiserdapp.com/",
                    "_blank"
                  )}
                className="btn-main inline lead"
              >
                Trade Secondary Markets
              </span>
              <div className="mb-sm-30"></div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  );
};
export default tradesection;
